import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, money, API } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Download, ChevronRight, Lock } from "lucide-react";

export default function Sessions() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [rows, setRows] = useState([]);
  const [campuses, setCampuses] = useState([]);
  const [campus, setCampus] = useState("");

  useEffect(() => { api.get("/campuses").then(({ data }) => setCampuses(data)); }, []);
  useEffect(() => {
    const params = campus ? { campus_id: campus } : {};
    api.get("/sessions", { params }).then(({ data }) => setRows(data));
  }, [campus]);

  const cmap = Object.fromEntries(campuses.map((c) => [c.id, c.name]));
  const canExport = user.role === "admin" || user.role === "auditor";

  const exportCsv = () => { window.open(`${API}/exports/sessions.csv`, "_blank"); };

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div><h1 className="font-serif text-4xl">Sessions</h1><p className="text-[color:var(--ink-2)]">Count session history.</p></div>
        <div className="flex gap-2">
          {(user.role === "admin" || user.role === "auditor") && (
            <select className="field h-11 w-auto" value={campus} onChange={(e) => setCampus(e.target.value)} data-testid="sessions-campus">
              <option value="">All Campuses</option>
              {campuses.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          )}
          {canExport && <button className="btn btn-secondary h-11" onClick={exportCsv} data-testid="export-csv"><Download size={16} /> CSV</button>}
        </div>
      </div>

      <div className="card overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[color:var(--cream)] text-[color:var(--muted)]">
            <tr className="text-left"><th className="p-4">Date</th><th className="p-4">Campus</th><th className="p-4">Service</th><th className="p-4">State</th><th className="p-4 text-right">Grand</th><th className="p-4"></th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-[color:var(--line)] active:bg-[color:var(--sage-light)] cursor-pointer" onClick={() => nav(`/admin/sessions/${r.id}`)} data-testid={`session-row-${r.id}`}>
                <td className="p-4 font-medium">{r.date}</td>
                <td className="p-4">{cmap[r.campus_id] || "—"}</td>
                <td className="p-4">{r.service}</td>
                <td className="p-4"><span className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-xs font-semibold ${r.locked ? "bg-[color:var(--olive-light)] text-[color:var(--olive)]" : "bg-[color:var(--sage-light)] text-[color:var(--ink-2)]"}`}>{r.locked && <Lock size={11} />}{r.state}</span></td>
                <td className="p-4 text-right font-mono tabnum font-semibold">{money(r.computed_totals?.grand_total)}</td>
                <td className="p-4 text-right"><ChevronRight size={16} className="text-[color:var(--muted)]" /></td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={6} className="p-8 text-center text-[color:var(--muted)]">No sessions.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
